import type { BadgeTone } from '@/components/ui';
import type {
  QuestionRouteReason,
  QuestionStatus,
  StaffQuestion,
} from '@/features/patient-questions/types';

export const QUESTION_STATUS_LABEL: Record<QuestionStatus, string> = {
  open: 'Waiting for the clinic',
  answered: 'Answered',
  closed: 'Closed',
};

export const QUESTION_STATUS_TONE: Record<QuestionStatus, BadgeTone> = {
  open: 'warning',
  answered: 'info',
  closed: 'neutral',
};

export const QUESTION_ROUTE_REASON_LABEL: Record<QuestionRouteReason, string> =
  {
    ordering_doctor: 'the doctor who ordered the test',
    branch_inbox: 'any doctor of the branch',
    claimed: 'claimed by the replying doctor',
    reassigned: 'routed by the clinic manager',
  };

const FLAG_LABEL: Record<string, string> = {
  normal: 'Normal',
  low: 'Low',
  high: 'High',
  abnormal: 'Abnormal',
  critical: 'Critical',
};

const FLAG_TONE: Record<string, BadgeTone> = {
  normal: 'success',
  low: 'warning',
  high: 'warning',
  abnormal: 'warning',
  critical: 'danger',
};

export const flagLabel = (flag: string) => FLAG_LABEL[flag] ?? flag;
export const flagTone = (flag: string): BadgeTone =>
  FLAG_TONE[flag] ?? 'neutral';

/** "6.1 %" (missing parts skipped; "—" when there is no value). */
export function resultValue(q: StaffQuestion): string {
  const r = q.subject?.result;
  if (!r) return '—';
  return [r.value, r.unit].filter(Boolean).join(' ') || '—';
}

/** When the row last needed attention: waiting since (open) or the last message. */
export function lastActivity(q: StaffQuestion): string {
  return q.status === 'open' && q.waitingSince
    ? q.waitingSince
    : q.lastMessageAt;
}
